import request from 'request-promise';
import formToObject from 'form-to-object';
import responseHandler from 'response-handler';

export default function(formSelector, reloadOnSuccess, includeDisabledInputs)
{	//2016-06-01
	const formElement = document.querySelector(formSelector);
	formElement.addEventListener('submit', async event =>
	{
		event.preventDefault();
		
		if(formElement.submitting === true) return false;
		
		formElement.submitting = true;
		
		let formData = formToObject(event.target, false, false, !includeDisabledInputs);

		formData.submitter = event.submitter?.name || '';

		const formAction = formElement.getAttribute('action');
		const response = (typeof(formAction) === 'string')
			? await request.postURL(formAction, formData)
			: await request.post(formData);
		
		await responseHandler(response, reloadOnSuccess);
		
		formElement.submitting = false;
		
		return false;
	});
};